import { useEffect, useState } from 'react';
import { getAppList } from '../services/manage/settings';
import { ServiceRegionType } from '../type';

export const useAppList = (authContext: any, region: ServiceRegionType, isGroupManager: boolean) => {
    const [appListAll, setAppListAll] = useState<any[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let isMounted = true;

        const fetchAppList = async () => {
            try {
                setLoading(true);
                setError(null);

                const params = { token: authContext.token };
                const response = await getAppList(params, region);

                if (isMounted && response?.packageOnOffStatus) {
                    let filteredApps = response.packageOnOffStatus;

                    if (isGroupManager && response.groupIds) {
                        filteredApps = response.packageOnOffStatus.filter((app: any) => app.groupId && response.groupIds.includes(app.groupId));
                    }

                    setAppListAll(filteredApps);
                }
            } catch (error) {
                console.error('Error fetching app list:', error);
                if (isMounted) {
                    setError('Failed to fetch app list');
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        if (appListAll === null && authContext.token) {
            fetchAppList();
        }

        return () => {
            isMounted = false;
        };
    }, [authContext.token, region, isGroupManager, appListAll]);

    return { appListAll, loading, error };
};
